import { render, staticRenderFns } from "./fhd.vue?vue&type=template&id=55584c2b&scoped=true&"
import script from "./fhd.vue?vue&type=script&lang=js&"
export * from "./fhd.vue?vue&type=script&lang=js&"
import style0 from "./fhd.vue?vue&type=style&index=0&id=55584c2b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55584c2b",
  null
  
)

export default component.exports